import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import CommonTopsection from "../../components/TopSection";
import { useEffect, useState } from "react";
// import { SpinnerBlock } from "../../Utils/CustomComponent";
import CommonGrid from "../../components/CommonGrid";
import ErrorBoundary from "../../components/ErrorBoundary";
import {
  gridColumns_saveReports,
  gridColumns_scheduledReports,
  gridColumns_scheduledReports_RunTime,
} from "../../Utils/TableColumnDefs";
import { useDispatch, useSelector } from "react-redux";
import { setRunNewReport } from "../../store/reducers/reportDocumentSlice";
import {
  fetchScheduledReport,
  fetchSaveReport,
} from "../../store/reducers/reportDocumentSlice/api";
import Heading from "../../components/Heading";
import DynamicComponentRenderer from "../../components/DynamicComponentRenderer";
import { useAbortController } from "../../hooks/useAbortController";
import axios from "axios";
import urls from "../../Utils/urls";
import { oracleConfig } from "../../Utils/constant";
import { DownloadModal } from "../Dashboard";

const ReportsNDocuments = () => {
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.label
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleRunNewReport = () => {
    dispatch(setRunNewReport({}));
    navigate("/run-new-report");
  };

  const ButtonSection = () => {
    return (
      <article className="">
        <div className="d-flex justify-content-between align-items-center">
          <span>Reports & Documents</span>
          <div>
            <Button
              onClick={handleRunNewReport}
              className="text-white run-report-button"
            >
              Run a report
            </Button>
          </div>
        </div>
      </article>
    );
  };

  const componentConfig = [
    {
      component: <Heading className="col-sm-12" text="Reports and Documents" />,
      role: ["Both"],
      className: "col-sm-12 px-4",
    },
    {
      component: <CommonTopsection className="col-sm-12" />,
      role: ["Both"],
      className: "col-sm-12 px-4",
    },
    {
      component: <ButtonSection />,
      role: ["Both"],
      className: "col-sm-12 px-4 py-3",
    },
    {
      component: <Reports />,
      role: ["Both"],
      className: "col-sm-12",
    },
  ];

  const componentConfigForBorrower = [
    {
      component: <Heading className="col-sm-12" text="Reports and Documents" />,
      role: ["Both"],
      className: "col-sm-12 px-4",
    },
    {
      component: <ButtonSection />,
      role: ["Both"],
      className: "col-sm-12 px-4 py-3",
    },
    {
      component: <Reports />,
      role: ["Both"],
      className: "col-sm-12",
    },
  ];

  return (
    // <div style={{ overflowY: "scroll" }}>
    //   <section
    //     className=" rounded"
    //     style={{ background: "#eeeeee", minHeight: "100vh" }}
    //   >
    //     <article className="container-fluid">
    //       <div className="p-3 pb-0  mt-1">
    //         <h4>Reports and Documents</h4>
    //       </div>
    //       <CommonTopsection />
    //     </article>
    //     <article className="container-fluid">
    //       <div className="d-flex justify-content-between p-3 align-items-center">
    //         <span>Reports & Documents</span>
    //         <div>
    //           {/* <Button
    //             onClick={() => navigate("/create-new-report")}
    //             className="text-white me-4"
    //           >
    //             Create Report Request
    //           </Button> */}
    //           <Button onClick={handleRunNewReport} className="text-white">
    //             Run a report
    //           </Button>
    //         </div>
    //       </div>
    //     </article>
    //     <ErrorBoundary>
    //       <Reports />
    //     </ErrorBoundary>
    //   </section>
    // </div>
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <section
        className=" rounded py-5"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid">
          <DynamicComponentRenderer
            componentConfig={
              selectedRole !== "Borrower"
                ? componentConfig
                : componentConfigForBorrower
            }
          />
        </article>
      </section>
    </div>
  );
};
export default ReportsNDocuments;
const Reports = () => {
  const [refresh, setRefresh] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [scheduleId, setScheduleId] = useState(null);
  const [scheduledReport, setScheduledReport] = useState([]);
  const { signal } = useAbortController();
  const dispatch = useDispatch();
  const favouriteReport = useSelector(
    (state) => state.reportDocument.favouriteReport.data
  );
  const saveReport = useSelector(
    (state) => state.reportDocument.saveReport.data,
  );
  // const scheduledReport = useSelector(
  //   (state) => state.reportDocument.scheduledReport.data,
  // );
  const saveReportStatus = useSelector(
    (state) => state.reportDocument.saveReport.status
  );
  // const scheduledReportStatus = useSelector(
  //   (state) => state.reportDocument.scheduledReport.status,
  // );
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.value,
  );

  const userId = localStorage.getItem("apex_userid");

  // useEffect(() => {
  //   dispatch(fetchScheduledReport({ signal }));
  // }, [dispatch]);

  useEffect(() => {
    getScheduledRecords();
  }, [refresh, selectedRole]);

  useEffect(() => {
    // if (saveReportStatus === "idle") {
    dispatch(fetchSaveReport({ signal }));
    // }
  }, [dispatch]);

  async function getScheduledRecords() {
    try {
      const res = await axios.get(
        urls.reportsWidget.scheduleReports(userId, selectedRole),
        oracleConfig,
      );

      setScheduledReport(res?.data?.items);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <article className="container-fluid">
      {/* <ErrorBoundary>
        {saveReportStatus === "fulfilled" ? (
          <CommonGrid
            className={"pending-loan-submissions"}
            title={"Favorite Reports"}
            gridColumns={gridColumns_saveReports}
            columnData={favouriteReport}
          />
        ) : (
          <SpinnerBlock height="39vh" />
        )}
      </ErrorBoundary> */}
      <ErrorBoundary>
        {/* {saveReportStatus === "fulfilled" ? ( */}
        <CommonGrid
          className={"pending-loan-submissions savedReports"}
          title={"Saved Reports"}
          gridColumns={gridColumns_saveReports}
          columnData={saveReport}
          status={saveReportStatus}
        />
        {/* ) : (
          <SpinnerBlock height="39vh" />
        )} */}
      </ErrorBoundary>
      <ErrorBoundary>
        <CommonGrid
          className={"pending-loan-submissions scheduledReports"}
          title={"Scheduled Reports"}
          gridColumns={gridColumns_scheduledReports_RunTime(
            userId,
            setRefresh,
            setShowDownloadModal,
            setScheduleId,
          )}
          columnData={scheduledReport}
          // status={"fulfilled"}
        />
        {/* <CommonGrid
          className={"pending-loan-submissions scheduledReports"}
          title={"Scheduled Reports"}
          gridColumns={gridColumns_scheduledReports}
          columnData={scheduledReport}
          status={scheduledReportStatus}
        /> */}
      </ErrorBoundary>
      <DownloadModal
        show={showDownloadModal}
        setShow={setShowDownloadModal}
        scheduleId={scheduleId}
      />
    </article>
  );
};
